<script setup lang="ts">
import type { WidgetPosition } from '~/stores/auth'

defineProps<{
  position: WidgetPosition
}>()

const positionClasses: Record<WidgetPosition, string> = {
  'bottom-left': 'fixed bottom-6 left-6 flex flex-col items-start gap-3',
  'bottom-right': 'fixed bottom-6 right-6 flex flex-col items-end gap-3',
  'top-left': 'fixed top-6 left-6 flex flex-col items-start gap-3',
  'top-right': 'fixed top-6 right-6 flex flex-col items-end gap-3'
}
</script>

<template>
  <div
    class="hidden sm:flex z-50"
    :class="positionClasses[position]"
  >
    <slot />
  </div>
</template>
